import Vue from 'vue';
//@ts-ignore
import Flickity from 'vue-flickity';

Vue.component('Flickity', Flickity);
